"use strict";

var _toConsumableArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var Publisher =
/*#__PURE__*/
function () {
  function Publisher() {
    _classCallCheck(this, Publisher);

    this.subscribers = [];
    this.inBatch = false;
    this.pendingState = null;
  }

  _createClass(Publisher, [{
    key: "subscribe",
    value: function subscribe(subscriber) {
      var _this = this;

      if (!this.subscribers.includes(subscriber)) {
        this.subscribers = _toConsumableArray(this.subscribers).concat([subscriber]);
      }

      return function () {
        var subscriberIndex = _this.subscribers.indexOf(subscriber);

        if (subscriberIndex >= 0) {
          _this.subscribers = R.remove(subscriberIndex, 1, _this.subscribers);
        }
      };
    }
  }, {
    key: "notify",
    value: function notify(state) {
      if (this.inBatch) {
        this.pendingState = state;
        return;
      }

      this.subscribers.forEach(function (subscriber) {
        subscriber(state);
      });
    }
  }, {
    key: "batch",
    value: function batch(fn) {
      this.inBatch = true;
      fn();
      this.inBatch = false;

      if (this.pendingState !== null) {
        this.notify(this.pendingState);
        this.pendingState = null;
      }
    }
  }]);

  return Publisher;
}();

exports.Publisher = Publisher;